import { Colors } from './types'

export const colors: Colors = {
  daren: '#ea4673',
  accent: {
    100: '#ffffff',
    400: '#5c5f61',
    500: '#161b1d',
    600: '#14181a',
  },
  text: {
    50: '#f5f5f5',
    100: '#eaebec',
    200: '#cbcdce',
    300: '#abafb1',
    400: '#6c7477',
    500: '#2d383c',
    600: '#293236',
    700: '#222a2d',
    800: '#1b2224',
    900: '#000000',
  },
  background: {
    500: '#ffffff',
    600: '#F2F2F2',
    700: '#E6E6E6',
    800: '#D9D9D9',
    900: '#CCCCCC',
  },
  danger: {
    100: '#f0bfce',
    500: '#c1003a',
    900: '#5f001c',
  },
  success: {
    100: '#c3e5d1',
    500: '#109648',
    900: '#084a23',
  },
}
